/*
 * Define some utility date formats.
 * Each format has to respect Intl.DateTimeFormatOptions.
 */

export const DATE_SHORT: Readonly<Intl.DateTimeFormatOptions> = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const DATE_FULL: Readonly<Intl.DateTimeFormatOptions> = {
  year: 'numeric',
  month: 'long',
  day: '2-digit',
};
